var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02Metodologia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 258,
    height: 197,
    viewBox: "0 0 258 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 20.64,
    height: 2.16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAAJCAYAAACojtvVAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA2SURBVEhL7dChAQAgDMTAh1Vqyv4DgmGExuVMfNapvtG4/athjoU4FuJYiGMhjoU4FuJYRPIACUgBhSGdUtYAAAAASUVORK5CYII="
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342",
    transform: "translate(-687 -1136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_262",
    "data-name": "Rect\\xE1ngulo 262",
    width: 258,
    height: 197,
    transform: "translate(687 1136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(737 1162)",
    fill: "#fbeaf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_272",
    "data-name": "Grupo 272",
    transform: "translate(-868.598 -86.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_254",
    "data-name": "Grupo 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1929",
    "data-name": "Trazado 1929",
    d: "M1706.989,1320.737a23.41,23.41,0,1,0-40.215,16.286c3.213,3.307,5.947,7.345,5.947,11.957v3.452a10.858,10.858,0,0,0,21.715,0v-3.452c0-4.612,2.735-8.65,5.945-11.957A23.3,23.3,0,0,0,1706.989,1320.737Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_159",
    "data-name": "Rect\\xE1ngulo 159",
    width: 49.2,
    height: 68.16,
    transform: "translate(1658.998 1296.239)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAAEcCAYAAABkqTBXAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAiPSURBVHhe7dxJYhzHEUBRkmfxRr7/WayN7wKxBLYIAT1k5Dy8t5F2Rlflr4guyPj+9vb2jT7++58/ml3s//3/z++//pXGRFNZyzByCaou0RSYMZBUQsonmoCVI3lFROlE88LOoTwioOdEc8eJoTwioK9E84tQXhPQu6OjEUq+kwM6Mhqx1HNiPEdFM1ssuQduxuhPiueIaEYdslEHaWRUJ8SzdTQ9D88Kh8X1qGPLaHocjh0OheuUZ6toWh+CnZ+erl26LaJpecN3DuWRVtdzl2u5fDQtbvCJoTzi+n61bDRuZl+u929LRlPzBgolpnY8K17/paIRy1xOvR/LRFPrBomlvtPuzRLR1LgpYmnrpHCmjsZ0Wc8J92zaaEyXte18/6aMpvSCi2UeO97LH7/+OQ3B7KX0ftSYWLVNM2nEsr+SezzT/Z1i0gjmDCX3aaaJM3zS7PL0Id3qD8mh0QjmbKve/2HrmWAouY+l06rEkGgEw82K4XRfz3I/qFj2ttKDtGs0guGVFc5It/VMMKRY4X5P918EfCSYM+Xc95L1LqpLNDkfSDBnmzmc5tEIhlyzhtM0GsFQasZwmkUjGGqZLZwm0QiG2mY6H11eBLwiGFJEz0mraVM9mugPKhhaahFO1WgEQ2s5Z6Z2ONWiaTUK4bPRD9th32lMGUpEz0/Nh3qVaKxljDAqnOJoBMNII87TsPUMRqgxbYqiMWWYQe81rdukEQwt9Txf2dFEahUMsymZNlnR1NgLobZeD+fm65kpQ0+R85b78A9HY8qwk5zz3HTSmDKM0PrchaKJVCkYRmq5pjX/TgO7SY7GlGE1raaNSQNBSdGYMqyqxbQxaSDoZTSmDKurfS5NGvggZUhUi8aUYWY1z+fTaCKrGezi1bmvMmlMGVZQ65w+jMaUgfuKJ40pw46eDY1qLwJgBTUe8nejsZrBY0WTxmrGilLP7aPhYT2DoC/RWM3guexJYzVjZSUrmvUMgkQDQf+KJvX7jNWMHeSuaCYNBIkGgsLRWM043T/R+P0MJ8oZAtYzSPBxqIgGgkQDQaFovARgR9Fz/Xc0XgJAOusZJLoNF9FAkGggKDkaLwHgnUkDP0WGgmggSDQQJBoI+uEXmxBj0kCQaCDg2sxEA0GigSDRQJBoIEg0ECQaCBINBIkGgkQDQaKBINFAkGgg4Pp/eIoGgn74gxkQY9JAkGggSDQQJBr4KfK3MpKj8Qc44J1JA0GigSDRQKLb7zT/jsYvOCGdScPxoi+5QtF4gwYmDYSJBhJ8/N7/TzReBnCinK8c4Unjew2ns55BkGgg6F/R+F7DSVK/anzuImvS+F7DyaxnECQajpS7ml2+RJP6vcaKxqlMGggqisa0YUWl5/ZuNF49w+MOrGcQVByNFY2VlLw1u3kYjRUN7quynpk2rKDWOX0ajWnDiV6dey8COELNbahaNFY0dpCyXb2MxorG6mo/0KuuZ6YNJ0iKJjJthMNMIucx9Zx7EQBBydGYNqymxZS5mDQQFIrGtGEVrabMxaRhO60f2OFoTBt2Ep0yl+aTRjj01OO8ZUWTUyfMJvccd/lOY9rQQ+SclTz4s6OJ/o8Kh5Z6nq+iSWNNYwbRYErPbZf17Ma0YQfF0VjTGKn3lLlUmTTCYYQRwVy6rmcfCYcSI89PtWhqVQyv5ART83xWnTTWNGZU+4E+bD27EQ4R0fPSYgOqHk3ODykcUsxyTppMGuFQW875aDFlLs3WM+FQy0zBXJp+pxEOpWYL5tL8RYBwyDVjMJfm0eQSztlmDebSJZrcDyOcM81+37tNGuGQIvd+95oyl67rWc8PxnpWCObS/TtNzgc0bXhkxIN4yIsA4fBZzv0dtbkMieYiHG5WCuYyLJqLcFgtmMvQaC6jLwDjrBjMZXg0l+iFMG3ONMsDdopoLsI5S/T+zbSRTBNNDuGsaeVgLlNFM9vFob4dHnTTTRprGh/N+CCdcj0Tzp5WX8tupv1OI5y97BLMZekXAexp5mAuU0dj2uxht/sy/aSZ/anDczutZTfbrWemzbpWeUAuEY01bU273odlJo01bW8r3d/t1rMb02asyPVf7YG4VDSmDTNYbtJEwjFtxth5yly2Xc+glSWjMW3mtfuUuZg0ELRsNF4KzOeEKXM5YtJY0ahp6WhMmzWtft+O+U5j2rR10vVdPhrTZi073K9jJg3UclQ0VrQ2Uq/rLlvBFtFY0ejJegZBoqGLnbaBbaJJvSm+19R14vU0aSBINBAkGprb7e3mVtF49UwPJg3ZTn2pcmQ03qBRwqSBINFAkGhoaseXM6KBINFA0HbR+F0NrZk0ECQaCBINBIkGgkQDQaKBINFAkGggSDQQJBoIEg0EiQaCRANBooEg0UCQaCBINBAkGggSDQSJBoJEQ5aT/7TvsdH4e87kMmkgSDQQtGU0/mDgHHa9D0dPGt9r8px+3axnECQaCDo+GitaTOr12vl75bbReBlAK9YzkpnK70Tzk8NQ1+5TfutorGj1eLD8ZtL84lCQavtoItNGOPdFrssJ092kgaAjojFt8pkyX5k0dwjnnetw3zHReJPW1knX16R54PSnrCnz2FHRRJ+Gpx6c6Oc+bYqbNC+cFo5gXjsumpybfEo4p07WqCMnjXC+yvl8J06Zy7HrmXB+E0yM7zRBu4UjmLijo8m9+buEs+vkbO3725vrVnJ4VnzqnvZ5a7Oe/VRyEFZ7WgumnEnzQWkAMx+qnT9bb6L5pMbkmOmA7fZ5ZiCaO2octMvIw7bDZ5iVaB6odehuehy+FX/mFYnmidqH8KbmYWzxM4rlOdEkaBXPZ88O6ww/A+9Ek6jXoR1JMGlEE7RjPGKJEU2GXcIRSx7RFFg5HsHkE00FK8UjlnKiqWzGgIRSl2gamSEesbQhmk56RCSSPkQzUElIAhnl27e/AKGCyMEeysARAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_160",
    "data-name": "Rect\\xE1ngulo 160",
    width: 21.84,
    height: 61.92,
    transform: "translate(1662.118 1299.359)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAECCAYAAACRwKsSAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQESURBVHhe7do7ciJBFAVRgTebmZj9r0KhzchkVBItIGigP1VZn5fpgH248boNDqfT6c2W9fn+sQtL7AfthZ1L7K9KwM4VFpsCvi4Udg3g64bHrg183bDYLSFPDYfdIvLUENgtA1/XNXYvyFPH82d39Qad6m7ZPSJPdYPdM/JUF2dkBOhU08seBXmq2WWPBp1qbtkjIk81teyRoVPNYI8Onap+RiIgT1VddiToVDXsaNCpKtgRoVM4dlToFIodGTqFYUeHTiHYQv9UHFvoS0Wxhb6tGLbQ9xXBFnq+7NhCP674A9IuZcV21c/Lhi3067JgC70sbzbYbmxXvbxd2EKvyzMCthnbVa9vE7bQ2/KMgK3GdtXbW4Ut9L48I2CLsV31/lw22CJsV50nlw32EttV58tlgz3FdtV5c9lgYoM9xPaE5M9lg81iu+oyuWwwscHusD0h5XLZYGKD3WB7QsrmssHEBhMb7Bfbe10+lw0mNpjYYN/Y3msmlw0mNpjYYGKDiQ0mNtjR1z4ulw0mNpjYYGKDiQ0mNpjYYGKDiQ0mNpjYYGKDiQ0mNpjYYGKDiQ0mNpjYYGKDiQ0mNtjxz7+/h/N3K5zLBhMbTGwwscHEBvvG9o2EyWWDiQ0mNtgvtne7fC4bTGwwscFusL3bZXPZYGKD3WF7SsrlssHEBpvF9pSUyWWDPcR23flz2WBigz3F9pTkzWWDvcR23fly2WCLsF13nlw22GJs170/lw22Ctt172v1sgXfnmcEbBO2696WywbbjO2617dr2YKva/cZEXx53mywLNiue1nZli3467KeEcGf580Gy47tuh9XZNmCz1fsjAh+X9GbLfhtxR+Qgl8qjp0S/CcEOyU4iJ2KDo5ipyKD49ipqOBVsKNWDTviuqsuOxp49TMSCbyJmx0FvJkHZATwZrAj1BT26Otubtkjgzd5RkYF92aDNYs94rqbXvZo4J4RsOaxR1p3F8seBdwzAtYN9gjrdtlgXWH3vm6XDdYdds/rdtlgXWL3um6XDdYtdo/rdtlgXWP3tm6XDSY2WPfYPZ0Slw0mNtgQ2L2cEpcNJjbYMNg9nBKXDSY2mNhgYoOJDTYUdutvJC4bTGwwscHEBhMbTGwwscHEBhMbTGwwscHEBhMbTGwwscHEBhMbTGwwscHEBhMbTGwwscHEBhMbTGwwscGGw275/34uG0xsMLHBxAYbErvVh6TLBhMbbFjsFk+JywYbGru1dbtssOGxW1q3ywYLgd3Kul02WBjsFtYdatm1wcOdkZrgIW92LXAfkGCH0+l0/hqzz/cPDCD8ssmT4hn5igIX+xwBHv5mz1Xqjov9pNzoYi8oF7rYK9qLLvbGtsCLnbHnP8Db239IqjIsldnhCQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_243",
    "data-name": "Grupo 243"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_161",
    "data-name": "Rect\\xE1ngulo 161",
    width: 13.44,
    height: 6.72,
    transform: "translate(1682.038 1305.119)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAcCAYAAAA0u3w+AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADrSURBVFhH1dZLDoIwEIBh6g08mTvvqCu9mB6hZoCaSVNrh3n230DC6uu0QMo5L9D7/txuiJ2vl7TfhmwFHsX9KhI6vW4PUVwrT7AJEGeNNQfiLLCn/eoSnH3p81/nCixpQlXeotwkty77O6iZBPQLHM1jIThQMrCVBfooUgRYpwmmQlWAOA0sBakOxEljR6CmwJIk9B/SBYiTwPaQ7n8y1JdGq94iuU8QpzHNUMASF4qRIX6267jbFi9QyAniONOEhQo5QRx3muGBEAcZfovWUbfsFBPEUaY5xRlsRUFOCYRGkdMCoR5ye7YsH2PwjxZZGMHxAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_244",
    "data-name": "Grupo 244"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rect\\xE1ngulo_162",
    "data-name": "Rect\\xE1ngulo 162",
    transform: "translate(1673.398 1346.158)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    "data-name": "Grupo 245"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rect\\xE1ngulo_163",
    "data-name": "Rect\\xE1ngulo 163",
    transform: "translate(1673.398 1353.359)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_253",
    "data-name": "Grupo 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    "data-name": "Grupo 246"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_164",
    "data-name": "Rect\\xE1ngulo 164",
    width: 11.76,
    height: 11.76,
    transform: "translate(1648.438 1343.759)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAYAAABznEEcAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVGhD1dTLDcJADEXRSVqBBaH/WmBDL0EXASIQkvl55vluvPWRJQ/zPAcvnY/TYtnL7TowXSC+l/8MiDxiC/BqfE7JYgAki4gFkCQiBUByiFQASSFyACSDyAXwYiUQJQBmd0QpgLoiagCoG6IWgLogagKoOaI2gJoiLADUDGEFoCYISwCZI6wBZIpoASAzRCsAmSBaAqg6ojWAqiJ6AKgaoheAqiB6AqgY0RtARQgFAGUjVACUhVACUDJCDUBJCEUARSNUARSFUAbQLkIdQJsIDwD6i/ACoFWEJwD9ILwBaIHwCKA3wiuAHgjPABqmw8k1gFa/015KAEpGqAEoCaEIoGiEKoDGmOWUAbR7CXVACCHcAYd8t91rpswsAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_247",
    "data-name": "Grupo 247"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_165",
    "data-name": "Rect\\xE1ngulo 165",
    width: 15.84,
    height: 2.4,
    transform: "translate(1634.278 1319.278)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAKCAYAAAAAX4jpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABVSURBVEhL7dbLEQAQDEXRRCss0H8tbPQSn0nQw8vZkO0dM8EiQqam8gYAbXTWK90QaBF+O8gJgRzBcIkZPsIW9ITnIZSHUOFfIcj8RSx3fRrcDxXRBOesIAGbRkwtAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    "data-name": "Grupo 248"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_166",
    "data-name": "Rect\\xE1ngulo 166",
    width: 11.76,
    height: 11.76,
    transform: "translate(1648.438 1285.438)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAYAAABznEEcAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEhSURBVGhD1dlBDoIwEEZh4Cq6UO9/Ft14F8wDJVEptKXT/vMWpKEbvgxlQz+OY0e383Ve/HR/Pvr3UraBSwhAW3sq9dfTJeohlScyTSIm5YlEI0gVkoQgRUgygtQgQ+6BVYJMk/AOWV4nz5CvM+EV8newPUJWv07eIKsI8gQJIsgLZBNBHiC7CFKHRCFIGRKNIFVIEoIUIckIUoNkIUgJko0gFcghBClADiOoNaQIglpCiiGoFaQoglpAiiOoNsQEQTUhZgiqBTFFUA2IOYKsIVUQZAmphiArSFUEWUCqI6g0pAmCSkKaIagUpCmCSkCaI+goZPkZr1Do4O4lMYlPuRORQlAORA5BqRBJBKVAZBEUC5FG0B6EfXkEhSDz/a57AaRut2uCDheeAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_249",
    "data-name": "Grupo 249"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_167",
    "data-name": "Rect\\xE1ngulo 167",
    width: 2.16,
    height: 15.84,
    transform: "translate(1682.518 1271.278)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAABCCAYAAACFDvy/AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABTSURBVEhLY/z//z8DCGipaEIYSODaneuMIJoJRGBTAAIwcUZNZQ2sCpAB2CRCYFTRqKJRRUAwqmhU0agiIBhVNKpokCqCtZFwAZA8zkYWQjMDAwAmkhfvAKrycgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_250",
    "data-name": "Grupo 250"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_168",
    "data-name": "Rect\\xE1ngulo 168",
    width: 12,
    height: 11.76,
    transform: "translate(1706.758 1285.438)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAxCAYAAACYq/ofAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEgSURBVGhD1dVBDoIwEEbhwlV0od7/LLrxLphHgtEI0paZ9p+3IYTNfJkCwzRNKUK383V10PvzMXAd5zvxthC0PJPfyD/EZ9IbyUWQLKQEQZKQUgTJQWoQfLmkIDWIJRlILULqP3IUQd0hFgjqCrFCUDeIJYK6QKwR1BzigaCmEC8ENYN4IqgJxBtB7pAWCHKFtEKQG6QlglwgrRFkDumBIFNILwSZQXoiyATSG0GHIQoIOgRRQVA1RAlBVRA1BBVDFBFUBFFFUDZEGUFZEHUE7UIiIOgvJAqCNiGRELQKiYagH0hEBH1BoiLoDYmMoBkSHUGrL3tOSgiqgqghaLieLkXHShFBY8lgqgjKPlrKCJohe0OqI+i9ka1hIyBSSukF+ey7a/YlmScAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_251",
    "data-name": "Grupo 251"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_169",
    "data-name": "Rect\\xE1ngulo 169",
    width: 15.84,
    height: 2.4,
    transform: "translate(1717.078 1319.278)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAKCAYAAAAAX4jpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABZSURBVEhLY/z//z8DDGipaCI4wxxcu3OdEcoEA3BAjKQAQAewAGHUVNYYsYEAA6DAYIKyRzwYTRFQMJoioGA0IIBgtIxAAkzo9elIA/Dqc6Q2qEAAkQgYGAB3lCIVje8nigAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_252",
    "data-name": "Grupo 252"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_170",
    "data-name": "Rect\\xE1ngulo 170",
    width: 12,
    height: 11.76,
    transform: "translate(1706.758 1343.759)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAxCAYAAACYq/ofAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEoSURBVGhD1do7EoIwGEVhYCtaiPtfizbuBT0oCMojCXnc/xQMTCjyTRIq6q7rqqHruf0+vLo97vXnVr4R8ouYZgHUcNlC0N64Qj3EJXVM3Z4uXhNU3WaN78RUV8Z5a01TxARBSA3TQ0L3vRJmXBHrmNnWsoz5OyNWMYuH3SJmEULWMKsQsoTZhJAVzC6ELGCcIKSOcYaQMsYLQqoYbwgpYoIgpIYJhpAS5hCEVDCHIaSAiQKh0phoECqJiQqhUpjoECqBSQKh3JhkEMqJSQqhXJjkEMqByQKh1JhsEEqJyQqhVJjsEEqBKQKh2JhiEIqJKQqhWJjiEIqBkYDQUYwMhEIxNPuFQ6W1L9NWUisyFLIykhDyxchCyAcjDSEXDO/IQ2gL8x6rqiclJ75njZHs2AAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    "data-name": "Grupo 54"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    "data-name": "L\\xEDnea 18",
    y2: 19.183,
    transform: "translate(1586.848 1351.812)",
    fill: "none",
    stroke: "#051518",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_19",
    "data-name": "L\\xEDnea 19",
    x2: 19.184,
    transform: "translate(1577.255 1361.402)",
    fill: "none",
    stroke: "#051518",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M1614.06,1268.25a7.882,7.882,0,1,0,7.883-7.882,7.882,7.882,0,0,0-7.883,7.882Z",
    fill: "none",
    stroke: "#051518",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Metodologia);
export default __webpack_public_path__ + "static/media/02metodologia.49bd53f4d8d75d3dc68317aab14d862c.svg";
export { ForwardRef as ReactComponent };